<!-- Loading -->
<div *ngIf="loading" class="flex justify-center py-5">
	<nz-spin nzTip="Loading member tickets..."></nz-spin>
</div>

<!-- Error -->
<div *ngIf="!loading && error" class="alert alert-danger my-3">
	{{ error }}
</div>

<!-- No tickets -->
<div *ngIf="!loading && !error && modes.length === 0" class="text-muted py-3">
	No tickets found for this member.
</div>

<!-- Main content -->
<div *ngIf="!loading && !error">
	<div *ngFor="let mode of modes" class="mt-4">
		<h2 class="mb-2">{{ mode.mode }}</h2>

		<div *ngFor="let workflow of mode.workflows" class="mt-3">

			<h4 class="mb-2">{{ workflow.workflow.label }}</h4>

			<nz-table [nzData]="workflow.tickets" nzBordered [nzShowPagination]="false" nzSize="small" class="mb-4 shadow-sm">
				<thead>
					<tr>
						<th>Reference</th>
						<th>Lodged At</th>
						<th>Lodged By</th>
						<th>Assigned To</th>
						<th>Status</th>
						<th>Membership</th>
						<th>State</th>
						<th></th>
					</tr>
				</thead>

				<tbody>
					<tr *ngFor="let ticket of workflow.tickets" (dblclick)="openTicket(ticket)" class="cursor-pointer">
						<td>{{ ticket.ticketReference }}</td>
						<td>{{ ticket.createdAt | date:'medium' }}</td>

						<td>{{ ticket.createdByAgent.firstName }} {{ ticket.createdByAgent.lastName }}</td>

						<td>
							<span *ngIf="ticket.assignedToAgent; else noAgent">
								{{ ticket.assignedToAgent.firstName }} {{ ticket.assignedToAgent.lastName }}
							</span>
							<ng-template #noAgent>
								<span class="text-muted">Unassigned</span>
							</ng-template>
						</td>

						<td>{{ ticket.status }}</td>

						<td>
							<span *ngIf="ticket.membership; else noMembership">
								{{ ticket.membership.category }} - {{ ticket.membership.membershipNumber }}
							</span>
							<ng-template #noMembership>
								<span class="text-muted">None</span>
							</ng-template>
						</td>

						<td>
							<nz-alert [nzBanner]="true" [nzType]="getSlaClass(ticket)" [nzDescription]="ticket.currentStepAndStateLabel"></nz-alert>
						</td>
						<td>
							<button nz-button nzType="default" nzSize="small" (click)="showTicketHistory(ticket)">
								History
							</button>
						</td>
					</tr>
				</tbody>
			</nz-table>
		</div>
	</div>
</div>
